module.exports = __webpack_public_path__ + "static/media/company-logo-placeholder.89aa335f.svg";